// @ts-nocheck
import React from 'react'
import { useSelector } from 'react-redux';
import ProfilePictureRounded from '../ProfilePictureRounded';
import { useNavigate } from 'react-router-dom';
import { Skeleton, SkeletonGroup } from '../Skeleton';
import { ReactComponent as BuildingIcon } from '../../assets/icons/group-icon.svg';
import SettingsRow, { SettingsGroup } from '../Settings/SettingsRow';

const MyOrganizationList = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate()

  const { loaded, data } = user.organizations
  const organizationKeys = Object.keys(data)

  if(!loaded) {
    return (
      <SettingsGroup title="Organizations">
        {/* Sized like the rows it replaces, so nothing shifts when the list lands */}
        <SkeletonGroup count={2} label="Loading organizations" className="divide-y divide-eai-border">
          <div className="flex items-center gap-4 px-5 py-4">
            <Skeleton className="h-9 w-9" radius="full" />
            <div className="min-w-0 flex-1">
              <Skeleton className="h-4 w-40" radius="md" />
              <Skeleton className="mt-2 h-3.5 w-28" />
            </div>
          </div>
        </SkeletonGroup>
      </SettingsGroup>
    )
  }

  if (organizationKeys.length === 0) {
    return (
      <SettingsGroup title="Organizations">
        <div className="flex flex-col items-center px-5 py-10 text-center">
          <BuildingIcon aria-hidden className="h-8 w-8 text-eai-ink-ghost [&_path]:stroke-current" />
          <p className="eai-card-title mt-3">No organizations yet</p>
          <p className="eai-description-sm mt-1">Organizations you belong to will appear here.</p>
        </div>
      </SettingsGroup>
    )
  }

  return (
    <SettingsGroup title="Organizations">
      {organizationKeys.map((orgKey) => {
        const organizationData = data[orgKey]
        return (
          <SettingsRow
            key={orgKey}
            title={organizationData.name}
            description="View organization details"
            onClick={() => navigate(`/home/organization/${organizationData.id}`)}
            leading={
              <ProfilePictureRounded
                className="shrink-0 border border-eai-border transition-colors group-hover:border-eai-border-hover"
                pictureURL={organizationData?.profilePictureUrl}
                diameter={36}
              />
            }
          />
        )
      })}
    </SettingsGroup>
  )
}

export default MyOrganizationList
